// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

/* eslint-disable spire/fenced-imports */
import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Configuration";
import "@vanmeter/XDL";
import "@vanmeter/App/Libraries";
import "@vanmeter/App/Store/Reducers";
/**
 * Google Analytics Integration
 * Step: To enable Google Analytics, add below code to your start.tsx file
 */
// import "./App/Widgets/GoogleAnalyticsConnector/Store/Reducers";

// In production, code-split them into a separate chunk so they don't bloat public.js for storefront
// In development, load them eagerly for HMR support.
if (IS_PRODUCTION) {
    import(/* webpackChunkName: "editor-templates" */ "./App/EditorTemplatesLoader");
} else {
    const { loadEditorTemplates } = require("@insite/shell-public/EditorTemplatesLoader");
    const templates = require.context("./App/EditorTemplates", true, /\.tsx$/);
    const onHotTemplateReplace = loadEditorTemplates(templates);
    if (module.hot) {
        module.hot.accept(templates.id.toString(), () => {
            onHotTemplateReplace(require.context("./App/EditorTemplates", true, /\.tsx$/));
        });
    }
}

// Load all custom widgets so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const widgets = IS_PRODUCTION
    ? require.context("./App/Widgets", true, /(Header|Basic|Common|Footer|SignIn|GlobalNotificationBar)\/.+?\.tsx$/)
    : require.context("./App/Widgets", true, /\.tsx$/);

const onHotWidgetReplace = addWidgetsFromContext(widgets);
if (module.hot) {
    module.hot.accept(widgets.id.toString(), () =>
        onHotWidgetReplace(require.context("./App/Widgets", true, /\.tsx$/)),
    );
}

// Load all custom pages so they are included in the bundle and enable hot module reloading for them. Do not do this for the ./Overrides folder
const pages = require.context("./App/Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id.toString(), () => onHotPageReplace(require.context("./App/Pages", true, /\.tsx$/)));
}

// Load all handlers so they are included in the bundle.
const handlers = require.context("./App/Handlers", true);
handlers.keys().forEach(key => handlers(key));

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = IS_PRODUCTION
    ? require.context("./App/WidgetExtensions", true, /\.ts$/, "lazy-once")
    : require.context("./App/WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// Load all the extensions to the base components. This includes style extensions.
const componentExtensions = require.context("./App/ComponentExtensions", true);
componentExtensions.keys().forEach(key => componentExtensions(key));

// Load all the extensions to the base pages. This includes style extensions.
const pagesExtensions = require.context("./App/PageExtensions", true);
pagesExtensions.keys().forEach(key => pagesExtensions(key));

// const googleAnalyticsHandlers = require.context("./App/Widgets/GoogleAnalyticsConnector/Handlers", true);
// googleAnalyticsHandlers.keys().forEach(key => googleAnalyticsHandlers(key));
/**
 * End Google Analytics Integration
 */
